var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "DropdownCaret",

    getDefaultProps () {
        return {"data-svgreactloader":"[[null,\"rdf\",\"http://www.w3.org/1999/02/22-rdf-syntax-ns#\"],[\"http://www.w3.org/2000/svg\",\"cc\",\"http://creativecommons.org/ns#\"],[\"http://www.w3.org/2000/svg\",\"dc\",\"http://purl.org/dc/elements/1.1/\"]]","xmlns":"http://www.w3.org/2000/svg","height":"12","width":"16","version":"1.1","viewBox":"0 0 15.999999 11.999999"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <g fill="#fff" transform="matrix(.66667 0 0 0.625 -88.14 -88.931)">
    <path d="m144.21 145.49 12 16h-24z" fill="#FFF"/>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/app/assets/dropdown-caret.svg